var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2984 25.7313C22.0596 25.7313 26.3034 19.3 26.3034 13.7263C26.3034 13.5425 26.3034 13.3588 26.2946 13.1838C27.1171 12.5888 27.8346 11.845 28.4034 10.9963C27.6509 11.3288 26.8371 11.5563 25.9796 11.6613C26.8546 11.1363 27.5196 10.3138 27.8346 9.32505C27.0209 9.8063 26.1196 10.1563 25.1571 10.3488C24.3871 9.5263 23.2934 9.0188 22.0771 9.0188C19.7496 9.0188 17.8596 10.9088 17.8596 13.2363C17.8596 13.5688 17.8946 13.8925 17.9734 14.1988C14.4646 14.0238 11.3584 12.3438 9.27586 9.7888C8.91711 10.41 8.70711 11.1363 8.70711 11.9063C8.70711 13.3675 9.45086 14.6625 10.5884 15.415C9.89711 15.3975 9.24961 15.205 8.68086 14.89C8.68086 14.9075 8.68086 14.925 8.68086 14.9425C8.68086 16.99 10.1334 18.6875 12.0671 19.0813C11.7171 19.1775 11.3409 19.23 10.9559 19.23C10.6846 19.23 10.4221 19.2038 10.1596 19.1513C10.6934 20.8313 12.2509 22.0475 14.0971 22.0825C12.6534 23.2113 10.8334 23.885 8.85586 23.885C8.51461 23.885 8.18211 23.8675 7.84961 23.8238C9.69586 25.0313 11.9184 25.7313 14.2984 25.7313Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.ca100faa5611f810433eeda929907d1a.svg";
export { ForwardRef as ReactComponent };